// src/components/theme.js
import { createTheme } from '@mui/material/styles';

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#36393f',
      paper: '#2f3136',
    },
    text: {
      primary: '#ffffff',
    },
  },
  typography: {
    fontFamily: "'Pretendard', sans-serif",
    },
  });

export const lightTheme = createTheme({
    palette: {
      mode: 'light',
      background: {
        default: '#f4f5f7',
        paper: '#fffaf2',
      },
      text: {
        primary: '#000000',
      },
    },
    typography: {
      fontFamily: "'Pretendard', sans-serif",
    }, 
  });